export default {
    BADREQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOTFOUND: 404,
    I_AM_A_TEA_POT: 418,
    INTERNAL_SERVER_ERROR: 500
};
